// extracted by mini-css-extract-plugin
export default {"status":"StepShow_status__Bzp-5"};